import CircleIcon from '@mui/icons-material/Circle';
import '../App.css';
import { StyleConstants, Styles } from '../Styles';

const RedLightIcon = () => {
    return (
        <CircleIcon 
            sx={{
                fill: StyleConstants.faultLevelOne,
                ...Styles.light,
            }}
        />
    );
};

export default RedLightIcon;